module.exports = __webpack_public_path__ + "static/media/29BDOS27.f26164b5.jpg";